/* unplugin-vue-components disabled */import { render } from "./settings-frame.vue?vue&type=template&id=1e3a601a&scoped=true"
import script from "./settings-frame.vue?vue&type=script&lang=js"
export * from "./settings-frame.vue?vue&type=script&lang=js"

import "./settings-frame.vue?vue&type=style&index=0&id=1e3a601a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3a601a"],['__file',"src/controls/settings-frame.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e3a601a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e3a601a', __exports__)) {
    api.reload('1e3a601a', __exports__)
  }
  
  module.hot.accept("./settings-frame.vue?vue&type=template&id=1e3a601a&scoped=true", () => {
    api.rerender('1e3a601a', render)
  })

}


export default __exports__